import React, { useEffect, useState } from "react";
import "../../../assets/scss/components/track-overlay.scss";
import "../../../assets/scss/components/modal.scss";
import { useSelector } from "react-redux";
import { ReleaseState, StoreState } from "@type/models/store";

interface PromotionState {
  artist_bio: string;
  facebook_link: string;
  twitter_link: string;
  instagram_link: string;
  youtube_link: string;
  linkedin_link: string;
}

interface Props {
  handleSubmission: (field: string, data: PromotionState) => void;
  callFunction: boolean;
  clearForm: boolean;
}

let initialsocialMedia = {
  artist_bio: "",
  facebook_link: "",
  twitter_link: "",
  instagram_link: "",
  youtube_link: "",
  linkedin_link: "",
};

const getLocalStorageData = () => {
  const storedData: any = localStorage.getItem("socialMedia");
  return JSON.parse(storedData);
};

const setLocalStorageData = (data: any) => {
  localStorage.setItem("socialMedia", JSON.stringify(data));
};
const Promotion: React.FC<Props> = ({
  handleSubmission,
  callFunction,
  clearForm,
}) => {
  const { promotion } = useSelector(
    (state: ReleaseState) => state.releaseInfo.releaseInfo
  );
  const [socialMedia, setSocialMedia] =
    useState<PromotionState>(initialsocialMedia);

  const handleChange = (field: keyof PromotionState, value: string) => {
    setSocialMedia({
      ...socialMedia,
      [field]: value,
    });
  };

  const handleSocialMediaChange = (
    field: keyof PromotionState,
    link: string
  ) => {
    handleChange(field, link);
  };

  const validateSocialMediaUrl = (url: string, socialMediaName: string) => {
    if (!url) {
      return true;
    }

    const regexPatterns: { [key: string]: RegExp } = {
      facebook_link:
        /(?:https?:\/\/)?(?:www\.)?facebook\.com\/.(?:(?:\w)*#!\/)?(?:pages\/)?(?:[\w\-]*\/)*([\w\-\.]*)/,
      twitter_link: /https?:\/\/twitter\.com\/([A-Za-z0-9_]+)/,
      instagram_link:
        /(?:https?:)?\/\/(?:www\.)?(?:instagram\.com|instagr\.am)\/([A-Za-z0-9_](?:(?:[A-Za-z0-9_]|(?:\.(?!\.))){0,28}(?:[A-Za-z0-9_]))?)/,
      youtube_link:
        /https?:\/\/(?:[A-Za-z]+\.)?youtube\.com\/(?:c\/([\w-]+)|channel\/([\w-]+)|user\/([\w-]+))/,
      linkedin_link:
        /^(https?:\/\/)?(www\.)?linkedin\.com\/(pub|in|profile)\/[a-zA-Z0-9-_.]+\/?$/,
    };
    if (
      regexPatterns[socialMediaName] &&
      !regexPatterns[socialMediaName].test(url)
    ) {
      return false;
    }

    return true;
  };
  const handleSubmit = () => {
    setLocalStorageData(socialMedia);
    if (
      socialMedia.artist_bio !== "" ||
      socialMedia.facebook_link !== "" ||
      socialMedia.twitter_link !== "" ||
      socialMedia.instagram_link !== "" ||
      socialMedia.youtube_link !== "" ||
      socialMedia.linkedin_link !== ""
    ) {
      handleSubmission("promotion", socialMedia);
    }
  };

  useEffect(() => {
    if (callFunction) {
      handleSubmit();
    }
  }, [callFunction]);

  useEffect(() => {
    setSocialMedia(initialsocialMedia);
  }, [clearForm]);

  useEffect(() => {
    const storedData = getLocalStorageData();
    if (storedData && Object.keys(storedData).length > 0) {
      setSocialMedia((prevSocialMedia) => ({
        ...initialsocialMedia,
        ...prevSocialMedia,
        ...storedData,
      }));
    }
  }, []);

  useEffect(() => {
    if (promotion) {
      setSocialMedia((prevErrors: any) => ({
        ...prevErrors,
        ...promotion,
      }));
    }
  }, [promotion]);

  return (
    <div className="container track-overlay-wrapper p-2">
      <div className="flex sm:flex-col">
        <div className="col-12 col-xl-4">
          <div className="fields-wrapper flex-grow-shrink flex justify-content-between items-center tw-gap-[20px] tw-my-[20px]">
            <label htmlFor="bio">Artist's Bio</label>
            <textarea
              id="bio"
              className="w-full p-2 border rounded text-lg h-32"
              value={socialMedia.artist_bio}
              onChange={(e) => handleChange("artist_bio", e.target.value)}
              rows={5}
            />
          </div>
        </div>

        <div className="col-12 col-xl-4">
          <div className="fields-wrapper flex-grow-shrink flex justify-content-between items-center tw-gap-[20px] tw-my-[20px]">
            <label className="" htmlFor="url-Facebook">
              Facebook
            </label>
            <input
              type="text"
              id="url-Facebook"
              value={socialMedia.facebook_link}
              onChange={(e) =>
                handleSocialMediaChange("facebook_link", e.target.value)
              }
            />
            {!validateSocialMediaUrl(
              socialMedia.facebook_link,
              "facebook_link"
            ) && <div className="text-danger">Invalid Facebook URL</div>}
          </div>
          <div className="fields-wrapper flex-grow-shrink flex justify-content-between items-center tw-gap-[20px] tw-my-[20px]">
            <label className="" htmlFor="url-Twitter">
              Twitter
            </label>
            <input
              type="text"
              id="url-Twitter"
              value={socialMedia.twitter_link}
              onChange={(e) =>
                handleSocialMediaChange("twitter_link", e.target.value)
              }
            />
            {!validateSocialMediaUrl(
              socialMedia.twitter_link,
              "twitter_link"
            ) && <div className="text-danger">Invalid Twitter URL</div>}
          </div>
          <div className="fields-wrapper flex-grow-shrink flex justify-content-between items-center tw-gap-[20px] tw-my-[20px]">
            <label className="" htmlFor="url-Instagram">
              Instagram
            </label>
            <input
              type="text"
              id="url-Instagram"
              value={socialMedia.instagram_link}
              onChange={(e) =>
                handleSocialMediaChange("instagram_link", e.target.value)
              }
            />
            {!validateSocialMediaUrl(
              socialMedia.instagram_link,
              "instagram_link"
            ) && <div className="text-danger">Invalid Instagram URL</div>}
          </div>
        </div>
        <div className="col-12 col-xl-4">
          <div className="fields-wrapper flex-grow-shrink flex justify-content-between items-center tw-gap-[20px] tw-my-[20px]">
            <label className="" htmlFor="url-YouTube">
              YouTube
            </label>
            <input
              type="text"
              id="url-YouTube"
              value={socialMedia.youtube_link}
              onChange={(e) =>
                handleSocialMediaChange("youtube_link", e.target.value)
              }
            />
            {!validateSocialMediaUrl(
              socialMedia.youtube_link,
              "youtube_link"
            ) && <div className="text-danger">Invalid YouTube URL</div>}
          </div>
          <div className="fields-wrapper flex-grow-shrink flex justify-content-between items-center tw-gap-[20px] tw-my-[20px]">
            <label className="" htmlFor="url-LinkedIn">
              LinkedIn
            </label>
            <input
              type="text"
              id="url-LinkedIn"
              value={socialMedia.linkedin_link}
              onChange={(e) =>
                handleSocialMediaChange("linkedin_link", e.target.value)
              }
            />
            {!validateSocialMediaUrl(
              socialMedia.linkedin_link,
              "linkedin_link"
            ) && <div className="text-danger">Invalid LinkedIn URL</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Promotion;
